import {
  div,
  button,
  span,
  input
} from '@srfnstack/fntags'

/**
 * A custom number spinner with large +/- buttons.
 * @param state - fnstate holding the number value
 * @param min - optional minimum value
 * @param max - optional maximum value
 * @param className - optional extra classes for the join wrapper
 * @param inputClass - optional extra classes for the input
 * @param joinItem - optional boolean, if true, applies join-item to buttons and input
 */
export const NumberSpinner = ({ state, min = 1, max = 100, class: className = '', inputClass = '', joinItem = false }) => {
  const itemClass = joinItem ? 'join-item' : ''

  const increment = () => {
    const val = parseInt(state()) || 0
    if (val < max) state(val + 1)
  }

  const decrement = () => {
    const val = parseInt(state()) || 0
    if (val > min) state(val - 1)
  }

  const handleInput = (e) => {
    let val = parseInt(e.target.value)
    if (isNaN(val)) return
    if (val < min) val = min
    if (val > max) val = max
    state(val)
  }

  return div({ class: `join ${className}` },
    button({
      class: `btn btn-outline btn-sm ${itemClass} px-3`,
      onclick: decrement,
      type: 'button'
    }, span({ class: 'material-symbols-rounded !text-lg' }, 'remove')),
    input({
      type: 'text',
      class: `input input-bordered input-sm ${itemClass} w-16 text-center font-bold text-base ${inputClass}`,
      value: state.bindAttr(() => state()),
      oninput: handleInput
    }),
    button({
      class: `btn btn-outline btn-sm ${itemClass} px-3`,
      onclick: increment,
      type: 'button'
    }, span({ class: 'material-symbols-rounded !text-lg' }, 'add'))
  )
}
